import React from 'react';
import './SnapGuides.css';

const GridOverlay = ({
  isVisible = false,
  gridSize = 20,
  className = ''
}) => {
  if (!isVisible) {
    return null;
  }

  const gridClass = gridSize <= 10 ? 'fine' : gridSize >= 40 ? 'coarse' : '';

  return (
    <div 
      className={`grid-overlay visible ${gridClass} ${className}`}
      style={{
        backgroundSize: `${gridSize}px ${gridSize}px`
      }}
    />
  );
};

export default GridOverlay;